import {
    devBaseUrl,
    devAsset,
    appPrefix,
    token,
    COOKIE_EXPIRATION_CHECKER,
    devDOMAIN,
    CLIAM_APPID,
} from 'Constantes/config.json';

const isDev = window.location.href.indexOf('localhost') > -1;

export const baseUrl = isDev ? devBaseUrl : process.env.REACT_APP_BASEURL;

export const asset = isDev ? devAsset : process.env.REACT_APP_ASSET;

export const DOMAIN = isDev ? devDOMAIN : process.env.REACT_APP_ASSET;

export { appPrefix, token, COOKIE_EXPIRATION_CHECKER, CLIAM_APPID };

export default isDev;
